module.exports = __webpack_public_path__ + "static/img/banner.fefcb6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/banner.png
// module id = GXyR
// module chunks = 1